<script>
    import  {Doughnut}  from 'vue-chartjs';
    export default {
        extends: Doughnut,
        props: ['data', 'options'],
        data(){
            return {
                localOptions: {
                    tooltips: {
                        bodyFontSize: 18,
                        titleFontSize: 18,
                    },
                    legend: {
                        labels: {
                            fontStyle: 'bold',
                        },

                    },
                    label: {
                        fontSize: 20,

                    },

                },
            };
        },
        mounted () {
            this.renderChart(this.data, this.localOptions);
        }
    };
</script>